import { render, staticRenderFns } from "./newCurrency.vue?vue&type=template&id=603eb5c0&"
import script from "./newCurrency.vue?vue&type=script&lang=js&"
export * from "./newCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports